import educationContentActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../util/createReducer';
import { combineReducers } from 'redux';

const CONTENT_TYPE_FILTER_INITIAL_STATE = 'all';
const SHOW_PENDING_CONTENT_INITIAL_STATE = false;

const actionValuePassthrough = (_: any, action: any) => action.value;

export const reducers = {
  query: createAsyncRequestReducer(
    educationContentActionTypes.FETCH_EDUCATION_CONTENT,
    {
      reducers: {
        [educationContentActionTypes.CHANGE_EDUCATION_CONTENT_IN_LIST]: (
          state,
          action,
        ) => {
          return {
            ...state,
            response: {
              ...(state.response as any as Record<any, unknown>),
              data: {
                recentEducationContent: (
                  state.response as any
                ).data.recentEducationContent.map((content: any) => {
                  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
                  return content.id === action.content.id
                    ? // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
                      action.content
                    : content;
                }),
              },
            },
          };
        },
      },
    },
  ),
  queryById: createAsyncRequestReducer(
    educationContentActionTypes.FETCH_EDUCATION_CONTENT_BY_ID,
  ),
  create: createAsyncRequestReducer(
    educationContentActionTypes.CREATE_EDUCATION_CONTENT,
  ),
  update: createAsyncRequestReducer(
    educationContentActionTypes.UPDATE_EDUCATION_CONTENT,
  ),
  delete: createAsyncRequestReducer(
    educationContentActionTypes.DELETE_EDUCATION_CONTENT,
  ),
  selectedContentType: createReducer(CONTENT_TYPE_FILTER_INITIAL_STATE, {
    [educationContentActionTypes.SET_SELECTED_CONTENT_TYPE_FILTER]:
      actionValuePassthrough,
  }),
  showPendingContent: createReducer(SHOW_PENDING_CONTENT_INITIAL_STATE, {
    [educationContentActionTypes.SET_SHOW_PENDING_CONTENT]:
      actionValuePassthrough,
  }),
};

export default combineReducers(reducers);
